<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "ACHIEVEMENTS.TITLE" | translate }}</div>
</mat-toolbar>

<ngx-spinner [fullScreen]="false" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>

<mat-tab-group mat-align-tabs="center" (selectedIndexChange)="changeSelectedRanking($event)">
    <mat-tab *ngFor="let ranking of rankings" [label]="ranking.name">
        <div class="content" fxLayout="column">
            <div class="listItem" fxLayout="row" *ngFor="let detail of achievements">
                <img
                    class="img-curso-custom"
                    [src]="detail.achievement.settings.badgeUrl || 'assets/images/gamification/achievement.png'"
                />

                <div class="media-body">
                    <span class="title" fxLayout="row">
                        {{ detail.achievement.name }}&nbsp;
                        <div class="points">+{{ detail.totalPoints }}pts</div>
                    </span>
                    <div class="data" *ngIf="detail.courseSummary?.name" fxLayout="row">
                        <b> {{ "ACHIEVEMENTS.DATA.COURSE" | translate }}: &nbsp;</b>
                        {{ detail.courseSummary?.name }}
                    </div>
                    <div class="data" *ngIf="detail.examSummary?.name" fxLayout="row">
                        <b> {{ "ACHIEVEMENTS.DATA.EXAM" | translate }}: &nbsp;</b>
                        {{ detail.examSummary?.name }}
                    </div>
                    <div fxLayout="row">
                        {{ detail.createdByData.createdAt | amTimeAgo }}
                        ({{ detail.createdByData.createdAt | amDateFormat: "DD/MM/YYYY HH:mm" }})
                    </div>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" style="margin-bottom: 10px">
                <button
                    id="botao-mais"
                    mat-flat-button
                    color="primary"
                    (click)="loadMore()"
                    [disabled]="isLoading"
                    *ngIf="achievements?.length < totalRows"
                >
                    {{ "ACHIEVEMENTS.SHOW_MORE" | translate }}
                </button>
            </div>

            <ng-container *ngIf="isLoading">
                <ghost-data *ngFor="let ghost of [1, 2, 3]" [show]="true" [opacity]="100 / ghost">
                    <div class="listItem">
                        <div class="img-curso-custom">
                            <div class="loader"></div>
                        </div>

                        <div class="media-body">
                            <span class="title"> loading... </span>
                            <div class="instructor">loading...</div>
                        </div>
                    </div>
                </ghost-data>
            </ng-container>

            <div class="action" *ngIf="!isLoading && achievements?.length == 0">
                <span class="action-description">>{{ "ACHIEVEMENTS.NO_DATA" | translate }}</span>
                <span class="material-icons icon"> sentiment_satisfied_alt </span>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>
